/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './doctor-hospital-attribute.reducer';

export const DoctorHospitalAttributeDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const doctorHospitalAttributeEntity = useAppSelector(state => state.doctorHospitalAttribute.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="doctorHospitalAttributeDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.detail.title">DoctorHospitalAttribute</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.id">Id</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.id}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.active">Active</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="tm_cursor">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.tm_cursor">Tm Cursor</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.tm_cursor}</dd>
          <dt>
            <span id="attributeName">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.attributeName">Attribute Name</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.attributeName}</dd>
          <dt>
            <span id="attributeType">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.attributeType">Attribute Type</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.attributeType}</dd>
          <dt>
            <span id="attributeValue">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.attributeValue">Attribute Value</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.attributeValue}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.createdBy}</dd>
          <dt>
            <span id="modifiedBy">
              <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.modifiedBy">Modified By</Translate>
            </span>
          </dt>
          <dd>{doctorHospitalAttributeEntity.modifiedBy}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.doctor">Doctor</Translate>
          </dt>
          <dd>{doctorHospitalAttributeEntity.doctor ? doctorHospitalAttributeEntity.doctor.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.doctorHospitalAttribute.hospital">Hospital</Translate>
          </dt>
          <dd>{doctorHospitalAttributeEntity.hospital ? doctorHospitalAttributeEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/doctor-hospital-attribute" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/doctor-hospital-attribute/${doctorHospitalAttributeEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DoctorHospitalAttributeDetail;
